import { Stack, Typography } from '@mui/material';
import TextFieldWithError from '../../../../components/FormComponents/TextfieldWithError';
import { Switch } from '../../../../components/FormComponents';

function CustomFilterForm({ formik, isNew = true }) {
  const {
    handleChange, getIn, values, errors, touched,
  } = formik;

  return (
    <Stack gap={1}>
      {isNew ? (
        <>
          <Stack mx={1} alignItems="center" direction="row" gap={1} justifyContent="space-between">
            <Typography>Do you want to enable email alert?</Typography>
            <Switch
              name="alert"
              label="Email Alert"
              value={values.alert}
              onChange={handleChange}
            />
          </Stack>

          <TextFieldWithError
            name="name"
            label="Name"
            value={values.name}
            onChange={handleChange}
            error={touched && getIn(errors, 'name')}
          />
        </>
      )
        : <Typography my={2}>Are you sure you want to update selected filters in current submenu?</Typography>}
    </Stack>
  );
}

export default CustomFilterForm;
